"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagSI = function FlagSI(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.46",
    width: "409.6",
    height: "89.44",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-55.39-66.72s-1.42,45.3-7.78,58C-71,6.94-78.95,11.5-90.72,15.71-102.49,11.5-110.4,6.94-118.27-8.7c-6.36-12.72-7.78-58-7.78-58a85.79,85.79,0,0,1,70.66,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-80.49-3.9a4.54,4.54,0,0,0-2.89-.95,4.49,4.49,0,0,0-2.89.95,7.47,7.47,0,0,1-4.47,1.4,7.46,7.46,0,0,1-4.48-1.41,4.55,4.55,0,0,0-2.88-.94,4.55,4.55,0,0,0-2.88.94,7.5,7.5,0,0,1-4.14,1.39c4.29,5.23,8.78,7.71,14.4,9.86,5.61-2.15,10.1-4.63,14.39-9.86A7.63,7.63,0,0,1-80.49-3.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-108.34-12.27a4.53,4.53,0,0,0,2.88.94,4.54,4.54,0,0,0,2.89-.94,7.4,7.4,0,0,1,4.47-1.41,7.4,7.4,0,0,1,4.47,1.41,4.54,4.54,0,0,0,2.89.94,4.49,4.49,0,0,0,2.88-.94,7.43,7.43,0,0,1,4.48-1.41,7.4,7.4,0,0,1,4.47,1.41,4.57,4.57,0,0,0,2.9.95,4.54,4.54,0,0,0,2.89-.95,7.74,7.74,0,0,1,3.48-1.32,33.56,33.56,0,0,0,1.23-3.92L-78.95-35.07l-3.92,7.85-7.85-15.7-7.85,15.7-3.93-7.85L-113-17.52a33.09,33.09,0,0,0,1.23,3.93,7.53,7.53,0,0,1,3.46,1.32Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-71.54-9.79A7.4,7.4,0,0,1-76-8.38a7.41,7.41,0,0,1-4.48-1.41,4.54,4.54,0,0,0-2.89-1,4.54,4.54,0,0,0-2.89,1,7.4,7.4,0,0,1-4.47,1.41,7.46,7.46,0,0,1-4.48-1.41,4.49,4.49,0,0,0-2.88-1,4.49,4.49,0,0,0-2.88,1,7.46,7.46,0,0,1-4.48,1.41,7.39,7.39,0,0,1-4.46-1.41h0c.77,1.39,1.53,2.68,2.3,3.84a4.15,4.15,0,0,0,2.17.52,4.54,4.54,0,0,0,2.89-.94A7.4,7.4,0,0,1-98.1-7.79a7.47,7.47,0,0,1,4.47,1.4,4.49,4.49,0,0,0,2.89.95,4.49,4.49,0,0,0,2.88-.94,7.43,7.43,0,0,1,4.48-1.41,7.4,7.4,0,0,1,4.47,1.41,4.57,4.57,0,0,0,2.9.94A4.17,4.17,0,0,0-73.81-6q1.16-1.74,2.31-3.84l0,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-90.56-56.44l.68,2.25,2.3-.53a.16.16,0,0,1,.15.27L-89-52.73l1.6,1.72a.16.16,0,0,1-.15.27l-2.3-.53L-90.56-49a.16.16,0,0,1-.31,0l-.69-2.25-2.3.53A.16.16,0,0,1-94-51l1.6-1.72L-94-54.45a.16.16,0,0,1,.15-.27l2.3.53.69-2.25a.16.16,0,0,1,.31,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-101.85-67.26l.69,2.25,2.29-.53a.17.17,0,0,1,.16.27l-1.61,1.72,1.61,1.73a.16.16,0,0,1-.16.26l-2.29-.53-.69,2.26a.16.16,0,0,1-.31,0l-.69-2.26-2.29.53a.16.16,0,0,1-.16-.26l1.61-1.73-1.61-1.72a.16.16,0,0,1,.16-.27l2.29.53.69-2.25a.16.16,0,0,1,.31,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-79.2-67.26l.69,2.25,2.29-.53a.17.17,0,0,1,.16.27l-1.6,1.72,1.6,1.73a.16.16,0,0,1-.16.26l-2.29-.53-.69,2.26a.16.16,0,0,1-.3,0l-.7-2.26-2.29.53a.16.16,0,0,1-.16-.26L-81-63.55l-1.61-1.72a.17.17,0,0,1,.16-.27l2.29.53.7-2.25a.16.16,0,0,1,.3,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59.45-68.43c0,1.25,0,2.52,0,3.88-.57,14.16-2.67,45-7.27,54.3-6.77,13.59-13,18.09-24,22.23-11-4.14-17.27-8.64-24-22.22-4.61-9.33-6.73-40.7-7.27-54.31,0-1.36,0-2.61,0-3.88-1.36.53-2.71,1.1-4.05,1.7.1,2.75.79,20.8,2.84,36.66,1.16,8.86,2.76,17,4.93,21.37,7.87,15.64,15.78,20.2,27.55,24.41C-78.95,11.5-71,6.94-63.17-8.7-61-13-59.4-21.21-58.23-30.07c2-15.86,2.73-33.91,2.83-36.66-1.34-.6-2.69-1.17-4.05-1.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff1722"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagSI;
exports["default"] = _default;